import { render, staticRenderFns } from "./AttributeReferenceBorderValue.vue?vue&type=template&id=64b08c5a&scoped=true&"
import script from "./AttributeReferenceBorderValue.vue?vue&type=script&lang=ts&"
export * from "./AttributeReferenceBorderValue.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeReferenceBorderValue.vue?vue&type=style&index=0&id=64b08c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b08c5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab})
